import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { InputText, Table } from "@pentabd/ui";

import { ErrorModal, SuccessModal } from "@components";
import SubTasksListTableColumn from "./SubTasksListTableColumn";
import { IconSearch } from "@pentabd/icons";

import { Pagination } from "@type/taskManagement/pagination";
import { useNavigate, useParams } from "react-router-dom";
import useActionCreator from "@redux/hooks/useActionCreator";

import { SelectControllerOptions } from "@components/SelectControllerOptions";
import { StatusOptions } from "@type/taskManagement/common";
import { useSubTasksList } from "@hooks/taskManagement/subTasks/useSubTasksList";
import { SubTasksResponseType } from "@type/taskManagement/subTasks";

type Props = {
  statusOptions: StatusOptions;
};

const SubTasksListTable = ({ statusOptions }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();

  const { handleQuery, subTasksState } = useSubTasksList();

  const { getData, deleteSuccess, deleteError } = subTasksState;

  const { data, pagination } = getData || ({} as SubTasksResponseType);

  const { page, total, size } = pagination || ({} as Pagination);

  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState<boolean>(false);
  const [isErrorModalOpen, setIsErrorModalOpen] = useState<boolean>(false);

  const { taskManagementActionsHandlers } = useActionCreator();

  const { subTasksDeleteActionHandler } = taskManagementActionsHandlers;

  const handleStatus = (value: string) => {
    if (value !== "all") {
      handleQuery("status", value);
    } else {
      handleQuery("status", "");
    }
  };

  const successAction = () => {
    setIsSuccessModalOpen(false);
    handleQuery("page", 1);
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
  };

  useEffect(() => {
    if (deleteSuccess) setIsSuccessModalOpen(true);
    else if (deleteError) setIsErrorModalOpen(true);
  }, [deleteSuccess, deleteError]);

  return (
    <>
      <div className="mt-10">
        <Table
          columns={
            SubTasksListTableColumn(
              t,
              navigate,
              subTasksDeleteActionHandler,
              params,
            ) as any
          }
          rows={data || []}
          headerExtension={{
            leftComponents: [
              <div className="row">
                <div className="col-12 col-lg-6 col-xl-4 m-0 pt-5 px-5">
                  <SelectControllerOptions
                    label={t("TM_SUB_TASKS.TASKS_LIST.TABLE.STATUS_FILTER")}
                    name={"status"}
                    options={statusOptions}
                    actionHandler={handleStatus}
                    defaultValue="all"
                  />
                </div>
              </div>,
            ],
            rightComponents: [
              <div className="d-flex">
                <InputText
                  name="simple-input"
                  onChange={(e) => {
                    handleQuery("search", e.target.value);
                  }}
                  prefix={<IconSearch fill="dark" size="20" />}
                  size="sm"
                  placeholder={t("TM_SUB_TASKS.TASKS_LIST.TABLE.SEARCH")}
                  type="text"
                  controlling
                />
              </div>,
            ],
          }}
          // edit={{
          //   customIcon: <IconEdit01 size={24} fill="subtitle1" />,
          //   onClick: (id) => navigate(`${id}`),
          // }}
          // remove={{
          //   customIcon: <IconTrash01 size={24} fill="danger" />,
          //   onClick: (id) => {
          //     subTasksDeleteActionHandler(params?.id || "", id as number);
          //   },
          // }}
          pagination={{
            totalPage: Math.ceil(total / size),
            onClick: (currentPage) => {
              handleQuery("page", currentPage);
            },
            activePage: page,
          }}
        />
      </div>
      {/* modals  */}
      {isSuccessModalOpen && (
        <SuccessModal
          isModalOpen={isSuccessModalOpen}
          action={successAction}
          subtitle={"You have deleted a sub task"}
        />
      )}

      {isErrorModalOpen && (
        <ErrorModal
          isModalOpen={isErrorModalOpen}
          closeModal={closeErrorModal}
        />
      )}
    </>
  );
};

export default SubTasksListTable;
